export const WEAR_PRODUCTS = [
  {
    id: "placeholder-w1",
    title: "The Sunday Dress",
    handle: "the-sunday-dress",
    category: "DRESSES",
    fit: "Runs True",
    price: 89,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1619086303291-0ef7699e4b31?w=600&h=800&fit=crop&crop=center",
    color: "#FDEAEB",
  },
  {
    id: "placeholder-w2",
    title: "Comfort Stretch Jeans",
    handle: "comfort-stretch-jeans",
    category: "BOTTOMS",
    fit: "Generous",
    price: 75,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1657550853413-a646ba6a1877?w=600&h=800&fit=crop&crop=center",
    color: "#EDE4F0",
  },
  {
    id: "placeholder-w3",
    title: "Everyday Tee",
    handle: "everyday-tee",
    category: "TOPS",
    fit: "True",
    price: 35,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1601802455383-a56d602d43c0?w=600&h=800&fit=crop&crop=center",
    color: "#FFF5E6",
  },
  {
    id: "placeholder-w4",
    title: "The Going-Out Top",
    handle: "the-going-out-top",
    category: "TOPS",
    fit: "Runs True",
    price: 55,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1773146916297-c9f61093c308?w=600&h=800&fit=crop&crop=center",
    color: "#F0EDE4",
  },
  {
    id: "placeholder-w5",
    title: "Lounge Set",
    handle: "lounge-set",
    category: "SETS",
    fit: "Generous",
    price: 95,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1770872937971-f6df56da0933?w=600&h=800&fit=crop&crop=center",
    color: "#FDEAEB",
  },
  {
    id: "placeholder-w6",
    title: "The Perfect Blazer",
    handle: "the-perfect-blazer",
    category: "OUTERWEAR",
    fit: "True",
    price: 120,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1767503306334-388b2d4ea155?w=600&h=800&fit=crop&crop=center",
    color: "#E8E4EE",
  },
];

export const BIG_LIVING_PRODUCTS = [
  {
    id: "placeholder-bl1",
    title: "Oversized Lounge Sofa",
    handle: "oversized-lounge-sofa",
    category: "FURNITURE",
    fit: null,
    price: 1299,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1554995207-c18c203602cb?w=600&h=800&fit=crop&crop=center",
    color: "#F5F0EB",
  },
  {
    id: "placeholder-bl2",
    title: "XL Camping Chair",
    handle: "xl-camping-chair",
    category: "OUTDOORS",
    fit: null,
    price: 149,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?w=600&h=800&fit=crop&crop=center",
    color: "#E8F0E4",
  },
  {
    id: "placeholder-bl3",
    title: "Weighted Comfort Blanket",
    handle: "weighted-comfort-blanket",
    category: "HOME",
    fit: null,
    price: 89,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=600&h=800&fit=crop&crop=center",
    color: "#FFF5E6",
  },
  {
    id: "placeholder-bl4",
    title: "First-Class Travel Kit",
    handle: "first-class-travel-kit",
    category: "TRAVEL",
    fit: null,
    price: 65,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600&h=800&fit=crop&crop=center",
    color: "#EDE4F0",
  },
  {
    id: "placeholder-bl5",
    title: "Garden Lounger",
    handle: "garden-lounger",
    category: "OUTDOORS",
    fit: null,
    price: 249,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&h=800&fit=crop&crop=center",
    color: "#E4EDE8",
  },
  {
    id: "placeholder-bl6",
    title: "The Big Bath Towel",
    handle: "the-big-bath-towel",
    category: "HOME",
    fit: null,
    price: 45,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=800&fit=crop&crop=center",
    color: "#FDEAEB",
  },
];
